import { useQuery } from "@tanstack/react-query";
import { getOnlineRegistration } from "../Service/Api";
import { Link } from "react-router-dom";
function OnlineRegistration() {
  const {
    data: regData = [],
    isLoading,
    isFalse,
    error,
  } = useQuery({
    queryKey: ["getOnlineRegistration"],
    queryFn: getOnlineRegistration,
  });

  console.log("what is online reg", regData);

  return (
    <>
      {regData.map(function (item, index, arr) {
        return (
          <div key={item._id} className="onlineRegContainer">
            <h3>{item.title} </h3>
            <Link
              to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments?.[0]}`}>
              <i className="bi bi-paperclip"></i>
            </Link>
          </div>
        );
      })}
    </>
  );
}
export default OnlineRegistration;
